import { useContext } from 'react';
import I18nContext from '@/contexts/i18n/i18n.context';

export default function useI18n() {
  const context = useContext(I18nContext);

  if (!context) {
    throw new Error('useI18n: useI18n() must be used within the context');
  }

  return context;
}
